import { useMutation, UseMutationOptions } from '@tanstack/react-query';
import { AxiosError, AxiosInstance } from 'axios';

import { useZepApiClient } from '../ZepApiProvider';

/**
 * @deprecated API type 마이그레이션이 필요합니다. README의 API Type Safety 가이드를 참고하세요: docs/api-type-safety.md
 */
export async function fetchPostPhoneNumber(
  client: AxiosInstance,
  params: { spaceHashId: string; phoneNumber: string },
) {
  const { data } = await client.post('/space-plans/phone-number', {
    ...params,
  });
  return data.data;
}

/**
 * @deprecated API type 마이그레이션이 필요합니다. README의 API Type Safety 가이드를 참고하세요: docs/api-type-safety.md
 */
export function usePhoneNumberPurchaseComplete(
  spaceHashId: string,
  options?: UseMutationOptions<
    {
      status: number;
      statusKey: string;
      data: unknown;
    },
    AxiosError,
    string
  >,
) {
  const client = useZepApiClient();

  return useMutation(
    ['post-phone-number'],
    async (phoneNumber: string) =>
      fetchPostPhoneNumber(client, { spaceHashId, phoneNumber }),
    {
      ...options,
    },
  );
}
